import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { styled } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack';

const root = ReactDOM.createRoot(document.getElementById('root'));
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  // '&.notistack-MuiContent-warning': {
  //   backgroundColor: '#ffb856',
  //   color: "#000",
  // },
}));

root.render(
  <React.StrictMode>
    <StyledSnackbarProvider
      maxSnack={3}
      autoHideDuration={8000}
      dense={true}
      disableWindowBlurListener={true}
    // anchorOrigin={{
    //   vertical: 'top',
    //   horizontal: 'center',
    // }}
    >
      <App />
    </StyledSnackbarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
